import {useLocation, useNavigate} from "react-router";
import {SaveParams} from "utils";
import {useEffect, useState} from "react";
import {AppBar, Box, Tab, Tabs} from "@mui/material";
import {ButtonMain} from "../buttons";
import {Svg} from "assets";

function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        "aria-controls": `scrollable-force-tabpanel-${index}`,
    };
}

function TabPanel(props) {
    const {boxClassName, children, value, index, ...other} = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box className={boxClassName} p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

export const SimpleTabs = ({
                               tabsLabels,
                               defaultTab,
                               tabsContent,
                               small,
                               customTabPanel,
                               className,
                               handelTextButton,
                               handleAdd,
                               headerComponent,
                               pushToHistory = true,
                           }) => {
    const [value, setValue] = useState(defaultTab);
    const location = useLocation();
    const navigator = useNavigate();
    const info = location?.state;
    const tab = info?.activeTab ? info?.activeTab : defaultTab;

    useEffect(() => {
        if (info?.activeTab && pushToHistory) {
            setValue(info?.activeTab);
        }
    }, [info]);

    useEffect(() => {
        return () => {
            const params = {
                ...info,
            };
            params["activeTab"] = defaultTab;
            if (pushToHistory) SaveParams(location?.pathname, navigator, params);
        };
    }, []);

    const changeTab = (selectedTab) => {
        const params = {
            ...info,
        };

        params["activeTab"] = selectedTab;
        if (pushToHistory) {
            SaveParams(location?.pathname, navigator, params);
        } else {
            setValue(selectedTab);
        }
    };

    return (
        <div className={`simple-tab-wrapper ${className ? className : ""}`}>
            <div className="simple-tab-header-wrapper">
                <AppBar className="simple-tab-header" position="static">
                    <Tabs
                        value={value ? value : tab}
                        indicatorColor="primary"
                        aria-label="scrollable force tabs example"
                        scrollButtons="on"
                        variant="scrollable"
                    >
                        {tabsLabels &&
                            tabsLabels.map((tabLabel, index) => {
                                if (tabLabel) {
                                    return (
                                        <Tab
                                            key={index}
                                            onClick={() => {
                                                changeTab(tabLabel?.label);
                                            }}
                                            className="simple-tab-label"
                                            label={tabLabel?.label}
                                            value={tabLabel?.label}
                                            {...a11yProps(tabLabel?.label)}
                                        />
                                    );
                                }
                            })}
                    </Tabs>
                </AppBar>
                {headerComponent?.(value)}
                {handelTextButton &&
                    handelTextButton(value) &&
                    handleAdd &&
                    handleAdd(value) && (
                        <ButtonMain
                            text={handelTextButton && handelTextButton(value)}
                            onClick={handleAdd(value)}
                            startIcon={<Svg.PlusSvg/>}
                            small
                            buttonMainStyles={{
                                width: "fit-content",
                                padding: "6px 12px",
                            }}
                        />
                    )}
            </div>
            {tabsContent &&
                tabsContent.map((tabContent, index) => {
                    if (tabContent && tabContent?.tab === (value ? value : tab)) {
                        return (
                            <TabPanel
                                key={index}
                                index={tabContent?.tab}
                                boxClassName={
                                    customTabPanel
                                        ? customTabPanel
                                        : small
                                            ? "tab-content-wrapper-small"
                                            : "tab-content-wrapper"
                                }
                                value={tabContent?.tab}
                            >
                                {tabContent?.tabComponent}
                            </TabPanel>
                        );
                    }
                })}
        </div>
    );
};
